import {
  Button,
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@cargomatic/ui';
import Tooltip from 'components/ui/Tooltip';
import { RATE_CONDITION_COLUMN_PREFIX } from 'constants/LaneRates';
import { Filter, PlusCircle } from 'lucide-react';
import React, { useMemo } from 'react';
import { cn } from 'utils/ui/classes';

const filtersList = [
  { key: 'customer', label: 'Customer' },
  { key: 'customerType', label: 'Customer Type' },
  { key: 'origin', label: 'Origin' },
  { key: 'destination', label: 'Destination' },
  { key: 'status', label: 'Status' },
  { key: 'effectiveStart', label: 'Validity Start' },
  { key: 'effectiveEnd', label: 'Validity End' },
];

const rateConditionFilters = [
  { key: 'Customer', label: 'Customer' },
  { key: 'OrderType', label: 'Order Type' },
  { key: 'EquipmentType', label: 'Equipment Type' },
  { key: 'EquipmentSize', label: 'Equipment Size' },
  { key: 'SteamshipOrRailroad', label: 'Steamship / Railroad' },
  { key: 'Hazardous', label: 'Hazardous' },
];

export function FiltersDropdown({
  activeFilters = [],
  onCheckedChange,
  onRemoveFilter,
  onReset,
}) {
  const filtersState = useMemo(() => {
    return filtersList.map((filter) => ({
      ...filter,
      selected: (activeFilters ?? []).includes(filter.key),
    }));
  }, [activeFilters]);

  const rateConditionsFiltersState = useMemo(() => {
    const filters = activeFilters
      .filter((filter) => filter.startsWith(RATE_CONDITION_COLUMN_PREFIX))
      .map((filter) => filter.replace(RATE_CONDITION_COLUMN_PREFIX, ''));

    return rateConditionFilters.map((filter) => ({
      ...filter,
      selected: (filters ?? []).includes(filter.key),
    }));
  }, [activeFilters]);

  function handleReset() {
    onCheckedChange([]);
    onReset();
  }

  function handleToggle(filter) {
    return (checked) => {
      if (checked) {
        onCheckedChange([...(activeFilters ?? []), filter]);
      } else {
        const index = activeFilters.findIndex((item) => item === filter);
        onCheckedChange([
          ...(activeFilters ?? []).slice(0, index),
          ...(activeFilters ?? []).slice(index + 1),
        ]);
        onRemoveFilter(filter);
      }
    };
  }
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger>
        <Tooltip content="Add Filter">
          <Button
            variant="outline"
            size="sm"
            className="flex items-center h-10"
          >
            <Filter className="w-4 h-4" />
          </Button>
        </Tooltip>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className={cn('w-[200px] p-0 overflow-y-auto')}
        align="start"
      >
        <DropdownMenuLabel>Lane Rates</DropdownMenuLabel>
        {filtersState.map((filter) => (
          <DropdownMenuCheckboxItem
            key={filter.key}
            onCheckedChange={handleToggle(filter.key)}
            checked={filter.selected}
          >
            <span>{filter.label}</span>
          </DropdownMenuCheckboxItem>
        ))}
        <DropdownMenuSeparator />
        <DropdownMenuLabel>Rate Conditions</DropdownMenuLabel>
        {rateConditionsFiltersState.map((filter) => (
          <DropdownMenuCheckboxItem
            key={filter.key}
            onCheckedChange={handleToggle(
              `${RATE_CONDITION_COLUMN_PREFIX}${filter.key}`,
            )}
            checked={filter.selected}
          >
            <span>{filter.label}</span>
          </DropdownMenuCheckboxItem>
        ))}
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={handleReset} className="pl-8">
          Reset
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
